import { Component, OnInit } from '@angular/core';
import {MessageService} from '../../../core/service/message.service';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent implements OnInit {
  constructor(public messageService: MessageService) { }

  /**
   *
   */
  ngOnInit(): void {
  }
}
